import { computed } from "vue";
import { useTimelineMapStore } from "@features/Pages/TimelineMapPage/_js/app/store/timelineMapStore";
import type { IEpoch } from "@features/Pages/TimelineMapPage/_js/app/interfaces/IEpoch";
import type { ITranslations } from "@features/Pages/TimelineMapPage/_js/app/interfaces/ITranslations";

export function useTimelineData() {
  const store = useTimelineMapStore();

  const epochs = computed<IEpoch[]>(() => store.epochs);
  const translations = computed<ITranslations>(() => store.translations);

  return {
    store,
    epochs,
    translations,
  };
}
